import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-neutral-950 py-4 md:py-8" data-id="element-98">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-neutral-900 border border-amber-900/40 rounded-lg p-4 md:p-8 text-center" data-id="element-100">
          <div className="flex justify-center mb-2 md:mb-3" data-id="element-101">
            <div className="bg-amber-400/10 p-3 rounded-full" data-id="element-102">
              <ShieldIcon className="w-10 h-10 text-amber-400" data-id="element-103" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-amber-50 mb-2 md:mb-3" data-id="element-104">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-base text-neutral-300 mb-2 md:mb-3 leading-relaxed" data-id="element-105">
            Abrís los tomos. Probás las recetas. Aplicás las técnicas. Si en 7
            días sentís que el material no cumplió tus expectativas: devolución
            del 100% — sin formularios, sin drama, sin explicaciones.
            <br data-id="element-106" />
            <br data-id="element-107" />
            Comprás sin riesgo. El único riesgo real es no arrancar.
          </p>

          <p className="text-lg font-bold text-amber-400" data-id="element-108">
            Tasa de devoluciones: menos del 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}